import { createSlice } from "@reduxjs/toolkit";

const LabelRefExist = createSlice({
  name: "LabelRefExist",
  initialState: "",
  reducers: {
    saveLabelRefExist: (state, action) => action.payload,
  },
});

export default LabelRefExist;
